module.exports = __webpack_public_path__ + "img/center front length to hem.549cd707.png";